import newMainLogo from '../assets/images/new_main_logo.svg';
import { Link } from 'react-router-dom';

export const MainLogo = ({ className = "" }) => {
    return (
        <Link to="/">
            <img src={newMainLogo} alt="아나톨레어학원 로고" className={`w-full h-auto ${className}`} />
        </Link>
    );
};
